import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {EndUserPricePlanModel} from './end-user-price-plan.model';

@Component({
  selector: 'app-end-user-price-plan-card',
  templateUrl: './end-user-price-plan-card.component.html',
})
export class EndUserPricePlanCardComponent implements OnInit {
  @HostBinding('class.price-plan-card-container') true;
  @Input() pricePlan: EndUserPricePlanModel;
  constructor() { }

  ngOnInit() {
  }

}
